import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { Variables } from "../../Variations/Variations";
import Util from "../../Classes/Util";
import { Modal, Button } from "react-bootstrap";
import ReactPaginate from "react-paginate";
import { toast } from "react-toastify";
import { AiOutlineRight } from "react-icons/ai";
import { MdManageSearch } from "react-icons/md";

const ListMedia = () => {
  const permissions = Util.decrypt(localStorage.getItem("Permissions"));
  const [Media, setMedia] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [showImageDetails, setShowImageDetails] = useState(false);
  const [imageDetails, setImageDetails] = useState(null);
  const LIMIT = 18;

  // Fetch and initialize
  useEffect(() => {
    fetch(Variables.API_URL + "UploadMedia/GetMedia", {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((result) => {
        setMedia(result);
        setFilteredData(result);
      });
  }, []);

  // Reset to first page on new filter
  useEffect(() => {
    setCurrentPage(0);
  }, [filteredData]);

  const handleSearch = (e) => {
     setCurrentPage(0);
    const q = e.target.value.toLowerCase();
    setFilteredData(
      q === ""
        ? Media
        : Media.filter((m) => m.ImageTitle.toLowerCase().includes(q))
    );
  };

  const handleImageDetails = (img) => {
    setImageDetails(img);
    setShowImageDetails(true);
  };

  const DeleteMedia = async () => {
    const res = await fetch(
      `${Variables.API_URL}UploadMedia/DeleteMedia/${imageDetails.MediaId}`,
      { method: "DELETE", headers: { Accept: "application/json" } }
    );
    const msg = await res.json();
    if (res.ok) {
      toast.success(msg);
      setShowImageDetails(false);
      setImageDetails(null);
      // refetch
      const refreshed = await fetch(
        Variables.API_URL + "UploadMedia/GetMedia"
      ).then((r) => r.json());
      setMedia(refreshed);
      setFilteredData(refreshed);
    } else {
      toast.error("Please check with the administrator");
    }
  };

  // Pagination logic
  const offset = currentPage * LIMIT;
  const currentData = filteredData.slice(offset, offset + LIMIT);
  const pageCount = Math.ceil(filteredData.length / LIMIT);

  return (
    <div className="rightSide">
      <div className="container-fluid mt-3">
        {/* Header & Breadcrumb */}
        <div className="row mb-3">
          <div className="col-6">
            <h2>Media Library</h2>
            <ul className="portalPath">
              <li>
                Home <AiOutlineRight />
              </li>
              <li>Media Library</li>
            </ul>
          </div>
          <div className="col-6 text-end">
            {permissions.UploadMedia && (
              <NavLink to="/admin/gazelle/Media/0" className="btn btn-primary">
                Add New
              </NavLink>
            )}
          </div>
        </div>

        {/* Search */}
        <div className="row mb-3">
          <div className="col-4 offset-8 text-end tblSearchBar position-relative">
            <span>
              <MdManageSearch />
            </span>
            <input
              type="text"
              placeholder="Search by name"
              className="form-control form-control-sm"
              onChange={handleSearch}
            />
          </div>
        </div>

        {/* Grid */}
        <div className="row">
          {currentData.map((image) => (
            <div className="col-2" key={image.MediaId}>
              <div className="imagecontainer">
                <div className="form-check">
                  <button
                    className="btn"
                    onClick={() => handleImageDetails(image)}
                  >
                    <img
                      alt="media"
                      className="form-control"
                      src={Variables.API_PUBLISHED + image.Image}
                    />
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
        {/* Pagination */}
        <div className="d-flex justify-content-center mt-4">
          <ReactPaginate
            pageCount={pageCount}
            onPageChange={({ selected }) => setCurrentPage(selected)}
            pageRangeDisplayed={4}
            marginPagesDisplayed={1}
            previousLabel={null}
            nextLabel={null}
            containerClassName="pagination"
            pageClassName="page-item"
            pageLinkClassName="page-link"
            activeClassName="active"
            breakLabel="..."
          />
        </div>

        {/* Image Details Modal */}
        {showImageDetails && (
          <Modal
            show={showImageDetails}
            onHide={() => setShowImageDetails(false)}
          >
            <Modal.Header closeButton>
              <Modal.Title>Image Details</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <p>
                <strong>Title:</strong> {imageDetails.ImageTitle}
              </p>
              <p>
                <strong>Path:</strong> {imageDetails.Image}
              </p>
              <p>
                <strong>Uploaded:</strong> {imageDetails.UploadedDate}
              </p>
            </Modal.Body>
            <Modal.Footer>
              {permissions.DeleteMedia && (
                <Button variant="danger" onClick={DeleteMedia}>
                  Delete
                </Button>
              )}
              <Button
                variant="secondary"
                onClick={() => setShowImageDetails(false)}
              >
                Cancel
              </Button>
            </Modal.Footer>
          </Modal>
        )}
      </div>
    </div>
  );
};

export default ListMedia;
